<template>
  <div class="wrapper col-6">
    <div class="animated fadeIn">
      <b-card
        header-tag="header"
        footer-tag="footer">
        <div slot="header">
          <i class="fa fa-edit"></i> User Profile
        </div>
        
        <!-- BEGIN MOFA FORM -->
        <b-form id="mofa">
            <b-container class="table">
              <b-row>
                <b-col sm="12">
                  <b-form>
                      <b-row>
                        <b-col class="col-12">
                            <h5>User Details</h5>
                            <hr>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Firstname<span class="required">*</span></label> 
                            <b-form-input type="text" id="firstname" v-model="user.firstname" @keyup.native="changeEventHandler" :disabled="user.id <= 2"></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.firstname') }}</small>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Lastname<span class="required">*</span></label> 
                            <b-form-input type="text" id="lastname" v-model="user.lastname" @keyup.native="changeEventHandler" :disabled="user.id <= 2"></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.lastname') }}</small>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Position<span class="required">*</span></label> 
                            <b-form-input type="text" id="position" v-model="user.position" @keyup.native="changeEventHandler" :disabled="user.id <= 2"></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.position') }}</small>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Organization/Agency<span class="required">*</span></label> 
                            <b-form-select :value="agencyId" disabled>
                              <option v-for="item in agencyList" :value="item.id" v-if="item.id == agencyId">{{item.name}}</option>
                            </b-form-select>

                            <!-- <b-form-select v-model="agencyId" 
                                   type="text" placeholder="Agency" 
                                   text-field="name" 
                                   value-field="id"
                                   title="description"
                                   :options="agencyList" disabled> 
                            </b-form-select> -->
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">E-mail<span class="required">*</span></label>
                            <b-form-input type="text" id="email_address" v-model="user.email_address" @keyup.native="changeEventHandler" disabled></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.email_address') }}</small>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">  
                          <b-form-group>
                            <label for="id">Phone</label> 
                            <b-form-input type="text" id="phone" v-model="user.phone" @keyup.native="changeEventHandler" :disabled="user.id <= 2"></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.phone') }}</small>
                          </b-form-group>
                        </b-col>
                      </b-row>   
                      <br>
                      <b-row>
                        <b-col class="col-12">
                            <h5>Account Details</h5>
                            <hr>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Username<span class="required">*</span></label> 
                            <b-form-input type="text" id="username" v-model="user.username" @keyup.native="changeEventHandler" disabled></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.username') }}</small>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>  
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Password<span class="required">*</span></label> 
                            <b-form-input type="password" id="credential" v-model="user.credential" @keyup.native="changeEventHandler" :disabled="user.id <= 2"></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('user.credential') }}</small>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group>
                            <label for="id">Confirm password<span class="required">*</span></label> 
                            <b-form-input type="password" id="confirm_credential" v-model="confirm_credential" @keyup.native="changeEventHandler" :disabled="user.id <= 2"></b-form-input>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('confirm_credential') }}</small>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row v-if="isAdmin">
                        <b-col>
                          <b-form-group>
                            <b-form-checkbox v-model="user.active" class="mb-0" @change="changeEventHandler">
                              Account is <span v-if="user.active">enabled</span><span v-else="user.active">disabled</span>
                            </b-form-checkbox>
                          </b-form-group>
                        </b-col>                        
                    </b-row>  
                    
                  </b-form>
                </b-col>
              </b-row>
              <br><br>
            </b-container>
        </b-form>
        <!-- END MOFA FORM -->

        <!-- FOOTER -->  
        <div slot="footer" class="float-right">
            <b-button variant="primary" @click="submitEventHandler" :disabled="!modified"><i class="fa fa-save"></i> Save</b-button>&nbsp;
            <b-button variant="secondary" @click="closeEventHandler"> <i class="fa fa-times"></i> Close</b-button>
        </div>
        <!--// FOOTER -->  

      </b-card>
    </div>

    <!--// MODAL Confirm Save -->   
     <b-modal title="Confirm" class="modal-primary" ref="confirmSaveModal" id="confirmSaveModal" @ok="confirmSaveEventHandler" @cancel="close" ok-title="Save" cancel-title="Cancel" centered>
        <p class="my-4">You have unsaved changes on this form.&nbsp;&nbsp;Do you want to Save or Cancel the changes?</p>     
    </b-modal>  
    <!--// MODAL Confirm Save -->

  </div>
</template>

<script>
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import NotificationService from '@/api/NotificationService'
import CommonService from '@/api/CommonService'
import UploadService from '@/api/UploadService'
import userProfileMixin from '@/mixins/validators/UserProfile-validators'

import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import FileUpload from '@/components/file-upload/FileUpload'
import toast from '@/mixins/toast'

export default {
  components: { 
    FileUpload
  },  
  mixins: [
    userProfileMixin
  ],
  data () {
    return {      
      confirm_credential: "",
      isAdmin: (this.$store.state.permission === constants.ADMIN),
      local: constants.DATE_LOCALE_EN
    }
  },
  computed: {

  ...mapGetters({
      user: types.GET_USER,
      modified: types.GET_MODIFIED,
      agencyList: types.GET_AGENCIES,      
      agencyId: types.GET_USER_AGENCY_ID      
    }),

  getAgencyName: function () {
      return (p) => {
        for(var obj of this.agencyList) {
          if (obj.id === p.agency_id) {
              if (obj.id == constants.AGENCY_OTHERS)
                  return obj.name +":"+ p.agency_others
              else   
                  return obj.name
          }
        }
      }
    }    
  },
  methods: {

    changeEventHandler() {

      this.$store.commit(types.MUTATE_MODIFIED, true)

    },

    confirmSaveEventHandler() {
      
      if (this.$store.state.new_notification) {
            setTimeout(function () {
              this.$refs.confirmAdminModal.show()
            }.bind(this), 300)
       } 
       else {
          this.close()
       }
    },

    closeEventHandler () {
      if (this.modified) {
          this.$refs.confirmSaveModal.show()
      } 
      else {
          this.close()
      }
    },

    close() {
        this.$store.commit(types.MUTATE_RESET_STATE)
        this.$store.commit(types.MUTATE_VIEW_MOFA, false)
        if (this.$store.state.permission === constants.ADMIN) {
            this.$router.replace('/dashboard')
        }    
        else {
            this.$router.replace('/user-dashboard')
        }      
    },

    submitToDLTEventHandler() {

      let submitted_id = constants.STATUS_SENT_TO_DLT
      let status = this.$_.find(this.$store.state.statusList, {id: submitted_id});
      let notes = this.$moment(new Date()).format('DD/MM/YYYY HH:mm') +'\n'+ status.name

      const payload = {
            id : this.notificationId,
            status_id : status.id,
            notes : notes,
            ehoc_ref: this.$store.state.ehocRef,
            last_updated_by: this.$store.state.userId
        }
        this.$store.dispatch(types.ACTION_UPDATE_NOTIFICATION_STATUS, payload)

        // modal dialog
        this.$refs.confirmAdminModal.hide()

        toast.success("Thank you for your submission. You will receive a confirmation email shortly.")  
        
        setTimeout(function () {            
            //this.$store.dispatch(types.ACTION_AGENCY_NOTIFICATION_LIST, this.$store.state.agencyId)            
            this.close()
        }.bind(this), 600)

    },

    submitEventHandler () {
        const $this = this

         this.$validate()
          .then(function(success) {

             if (success) {
                 const payload = {
                      id: $this.$store.state.user.user.id,
                      username: $this.$store.state.user.user.username,
                      firstname: $this.$store.state.user.user.firstname,
                      lastname: $this.$store.state.user.user.lastname,
                      credential: $this.$store.state.user.user.credential,
                      updated_date: $this.$moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                      email_address: $this.$store.state.user.user.email_address,
                      position: $this.$store.state.user.user.position,
                      phone: $this.$store.state.user.user.phone,
                      active: $this.$store.state.user.user.active  
                  }
                
                  if (payload.id == 0) {
                      // new record
                  } 
                  else {

                      // UPDATE User
                      $this.$store.dispatch(types.ACTION_UPDATE_USER, payload)

                      // UPDATE User
                      // UserService.updateUser(payload).then( (response) => {

                      //     if (response) {
                      //         // UPDATE User
                      //        $this.$store.commit(types.MUTATE_MODIFIED, false)  

                      //        toast.success("Saved successfully")    
                      //     }                               
                      // })
                  }

             }
             else {
               toast.error( "Please complete all required fields", "Error")
             }

          })
    } //-- submitEventHandler     
  },

  mounted() {

     this.$nextTick(function () {      
      setTimeout(function () {
         this.confirm_credential = this.$store.state.user.user.credential
      }.bind(this), 300)
      
    })

  } //-- mounted
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

span.required {
  color:red; 
}

hr {
    margin-top: 0px;
    margin-bottom: 1.5rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/forms/UserProfile.vue